import React, { useEffect, useRef, useState } from "react";
import "./Pharma.css";
import Testimonial from "../../../Testimonial/Testimonial";
import { Helmet } from "react-helmet";

const Pharma = () => {
  const techItemsRow1 = [
    { name: "Angular.js", logo: "/logos/angular.png" },
    { name: "HTML", logo: "/logos/html.png" },
    { name: "CSS3", logo: "/logos/css.png" },
    { name: "Bootstrap", logo: "/logos/bootstrap.png" },
    { name: "Javascript", logo: "/logos/javascript.png" },
    { name: "AmazonDB", logo: "/logos/amazon_dynamodb.png" },
    { name: "Appian", logo: "/logos/appian.png" },
    { name: "Laravel", logo: "/logos/laravel.png" },
    { name: "MariaDB", logo: "/logos/mariadb.png" },
    { name: "MongoDB", logo: "/logos/mongodb.png" },
    { name: "Android", logo: "/logos/android-5.png" },
    { name: "ERC-20", logo: "/logos/erc-20.png" },
    { name: "Ethereum", logo: "/logos/ethereum.png" },
    { name: "Flutter", logo: "/logos/flutter.png" },
    { name: "Ionic", logo: "/logos/ionic.png" },
    {
      name: "Artificial Intelligence",
      logo: "/logos/artificial-intelligence.png",
    },
    { name: "Augmented Reality", logo: "/logos/Augmented Reality.png" },
    { name: "Crda", logo: "/logos/crda.png" },
    { name: "Data Science", logo: "/logos/data-science.png" },
    { name: "Go Chain", logo: "/logos/gochain.png" },
  ];

  const techItemsRow2 = [
    { name: "Sass", logo: "/logos/saas.png" },
    { name: "JQuery", logo: "/logos/jquery.png" },
    { name: "Less", logo: "/logos/less.png" },
    { name: "Codeigniter", logo: "/logos/codeignitor.png" },
    { name: "Django", logo: "/logos/django.png" },
    { name: "Node JS", logo: "/logos/node js.png" },
    { name: "PHP", logo: "/logos/php.png" },
    { name: "Salesforce", logo: "/logos/salesforce.png" },
    { name: "SQL Server", logo: "/logos/sql-server.png" },
    { name: "MySQL", logo: "/logos/mysql-5.png" },
    { name: "IOS", logo: "/logos/ios.png" },
    { name: "Oracle 6", logo: "/logos/oracle.png" },
    { name: "PostgreSQL", logo: "/logos/postgresql.png" },
    { name: "React Native", logo: "/logos/react_native.png" },
    { name: "Solidity", logo: "/logos/Solidity.png" },
    { name: "Hyperledger", logo: "/logos/Hyperledger.png" },
    { name: "Internet Of Things", logo: "/logos/iot.png" },
    { name: "One Ledger", logo: "/logos/OneLedger.png" },
    { name: "Virtual Reality", logo: "/logos/virtual-reality.png" },
  ];

  const duplicatedRow1 = [...techItemsRow1, ...techItemsRow1];
  const duplicatedRow2 = [...techItemsRow2, ...techItemsRow2];

  const containerRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offset, setOffset] = useState(0);
  const animationRef = useRef();

  useEffect(() => {
    // Set initial container width
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollSpeed = 1; // Adjust speed as needed (pixels per frame)

    const animate = () => {
      setOffset((prevOffset) => {
        const maxOffset = row1Ref.current?.scrollWidth / 2 || 0;
        const newOffset = prevOffset + scrollSpeed;
        return newOffset >= maxOffset ? 0 : newOffset;
      });
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [containerWidth]);

  const [showModal, setShowModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const consultationOptions = [
    {
      id: 1,
      title: "Pharmacy Management Systems",
      description:
        "Comprehensive software solutions for efficient pharmacy operations and inventory management",
      whatsappMessage:
        "Hello, I'm interested in Pharmacy Management Systems consultation.",
    },
    {
      id: 2,
      title: "Pharmaceutical CRM",
      description:
        "Customer relationship management tailored for pharmaceutical businesses and healthcare providers",
      whatsappMessage:
        "Hello, I'm interested in Pharmaceutical CRM consultation.",
    },
    {
      id: 3,
      title: "Drug Discovery Platforms",
      description:
        "Advanced computational tools for accelerating pharmaceutical research and development",
      whatsappMessage:
        "Hello, I'm interested in Drug Discovery Platforms consultation.",
    },
    {
      id: 4,
      title: "Pharma Analytics",
      description:
        "Data-driven insights for market analysis, clinical trials, and regulatory compliance",
      whatsappMessage:
        "Hello, I'm interested in Pharma Analytics consultation.",
    },
    {
      id: 5,
      title: "Supply Chain Solutions",
      description:
        "End-to-end solutions for pharmaceutical supply chain management and logistics",
      whatsappMessage:
        "Hello, I'm interested in Supply Chain Solutions consultation.",
    },
    {
      id: 6,
      title: "Regulatory Compliance Systems",
      description:
        "Software solutions for FDA compliance, quality management, and audit trails",
      whatsappMessage:
        "Hello, I'm interested in Regulatory Compliance Systems consultation.",
    },
  ];

  const handleButtonClick = () => {
    setShowModal(true);
    setSelectedOption(null);
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  const handleWhatsAppRedirect = () => {
    if (selectedOption) {
      const message = encodeURIComponent(selectedOption.whatsappMessage);
      window.open(`https://wa.me/+919155599968?text=${message}`, "_blank");
      setShowModal(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedOption(null);
  };

  return (
    <div className="pharma-page">
      <Helmet>
        <title>
          Pharmaceutical Technology Solutions | Innovative Pharma Technology
          Services
        </title>
        <meta
          name="description"
          content="Explore our comprehensive pharmaceutical technology solutions including pharmacy management systems, drug discovery platforms, supply chain solutions, and regulatory compliance systems."
        />
        <meta
          name="keywords"
          content="pharmaceutical technology, pharmacy management, drug discovery, pharma CRM, pharma analytics, supply chain solutions, regulatory compliance, clinical trial software, pharma software, healthcare technology, pharmaceutical manufacturing, pharma marketing, pharmaceutical research, drug development, pharma logistics, quality management systems, FDA compliance, pharmaceutical data, pharma mobile apps, pharmaceutical blockchain, pharma investment analysis, pharma digital transformation, pharmaceutical SaaS, pharma AI solutions, pharma tech innovations, pharmaceutical predictive analytics, pharma workflow automation, pharmaceutical big data, pharma intelligence platforms"
        />
      </Helmet>

      {/* Hero Section */}
         <section class="pharma-hero">
        <div class="pharma-hero-content">
            <h1 class="pharma-hero-title">
                Transforming <span class="pharma-highlight">Pharmaceutical Technology</span>
            </h1>
            <p class="pharma-hero-description">
                We deliver cutting-edge pharmaceutical solutions that transform how
                drugs are discovered, developed, and distributed. From drug
                discovery platforms to pharmacy management systems and AI-powered
                analytics.
            </p>
            <div class="pharma-hero-buttons">
                <a href="/contact-us">
                    <button class="pharma-btn pharma-btn-primary">
                        Get Started
                    </button>
                </a>
                <button class="pharma-btn pharma-btn-secondary">
                    Learn More
                </button>
            </div>
        </div>
        <div class="pharma-hero-visual">
            <div class="pharma-lab-container">
                <div class="lab-shelves">
                    <div class="lab-equipment microscope"></div>
                    <div class="lab-equipment flasks">
                        <div class="flask flask-1"></div>
                        <div class="flask flask-2"></div>
                        <div class="flask flask-3"></div>
                    </div>
                    <div class="lab-equipment test-tubes">
                        <div class="test-tube tube-1"></div>
                        <div class="test-tube tube-2"></div>
                        <div class="test-tube tube-3"></div>
                    </div>
                    <div class="lab-equipment computer"></div>
                </div>
                <div class="lab-cabinets">
                    <div class="cabinet-door"></div>
                    <div class="cabinet-door"></div>
                    <div class="cabinet-door"></div>
                </div>
                <div class="lab-counter"></div>
            </div>
            
            <div class="molecule molecule-1">
                <div class="orbit orbit-1">
                    <div class="electron electron-1"></div>
                    <div class="electron electron-2"></div>
                    <div class="electron electron-3"></div>
                    <div class="electron electron-4"></div>
                </div>
                <div class="atom nucleus"></div>
            </div>
            
            <div class="molecule molecule-2">
                <div class="orbit orbit-2">
                    <div class="electron electron-1"></div>
                    <div class="electron electron-2"></div>
                    <div class="electron electron-3"></div>
                    <div class="electron electron-4"></div>
                </div>
                <div class="atom nucleus"></div>
            </div>
            
            <div class="molecule molecule-3">
                <div class="orbit orbit-1">
                    <div class="electron electron-1"></div>
                    <div class="electron electron-2"></div>
                    <div class="electron electron-3"></div>
                    <div class="electron electron-4"></div>
                </div>
                <div class="atom nucleus"></div>
            </div>
        </div>
    </section>

      {/* Services Section */}
      <section className="pharma-services">
        <div className="pharma-services-header">
          <h2 className="pharma-section-title">Our Pharmaceutical Solutions</h2>
          <p className="pharma-section-subtitle">
            Innovative pharmaceutical technology services designed to transform
            your healthcare operations, enhance patient experiences, and drive
            growth in the pharmaceutical industry.
          </p>
        </div>

        <div className="pharma-services-grid">
          {/* Pharmacy Management Card */}
          <div className="pharma-service-card">
            <div className="pharma-service-icon">
              <div className="pharma-icon pharma-icon-pharmacy"></div>
            </div>
            <h3>Pharmacy Management Systems</h3>
            <p>
              Comprehensive software for efficient pharmacy operations,
              inventory management, and prescription tracking.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Inventory Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Prescription Tracking</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Billing Automation</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Reporting & Analytics</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">40%</div>
                <div className="stat-label">Operational Efficiency</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">99%</div>
                <div className="stat-label">Accuracy</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Pharmaceutical CRM Card */}
          <div className="pharma-service-card">
            <div className="pharma-service-icon">
              <div className="pharma-icon pharma-icon-crm"></div>
            </div>
            <h3>Pharmaceutical CRM</h3>
            <p>
              Specialized customer relationship management for pharmaceutical
              companies and healthcare providers.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Healthcare Provider Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Automated Follow-ups</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Sales Tracking</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Client Portals</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">35%</div>
                <div className="stat-label">More Leads</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">50%</div>
                <div className="stat-label">Faster Response</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Drug Discovery Card */}
          <div className="pharma-service-card">
            <div className="pharma-service-icon">
              <div className="pharma-icon pharma-icon-discovery"></div>
            </div>
            <h3>Drug Discovery Platforms</h3>
            <p>
              Advanced computational tools and AI-powered platforms for
              accelerating pharmaceutical research.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Molecular Modeling</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>AI-Powered Screening</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Compound Libraries</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Research Collaboration Tools</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">60%</div>
                <div className="stat-label">Faster Research</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">30%</div>
                <div className="stat-label">Cost Reduction</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Supply Chain Card */}
          <div className="pharma-service-card">
            <div className="pharma-service-icon">
              <div className="pharma-icon pharma-icon-supplychain"></div>
            </div>
            <h3>Supply Chain Solutions</h3>
            <p>
              End-to-end solutions for pharmaceutical supply chain management,
              logistics, and inventory control.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Inventory Optimization</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Cold Chain Monitoring</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Logistics Tracking</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Demand Forecasting</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">25%</div>
                <div className="stat-label">Cost Savings</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">99.5%</div>
                <div className="stat-label">Delivery Accuracy</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Pharma Analytics Card */}
          <div className="pharma-service-card">
            <div className="pharma-service-icon">
              <div className="pharma-icon pharma-icon-analytics"></div>
            </div>
            <h3>Pharma Analytics</h3>
            <p>
              Data-driven insights for market analysis, clinical trials,
              regulatory compliance, and drug performance.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Market Trend Analysis</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Clinical Trial Analytics</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Drug Performance Tracking</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Regulatory Compliance Monitoring</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">95%</div>
                <div className="stat-label">Accuracy</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">30%</div>
                <div className="stat-label">Better Decisions</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Regulatory Compliance Card */}
          <div className="pharma-service-card">
            <div className="pharma-service-icon">
              <div className="pharma-icon pharma-icon-compliance"></div>
            </div>
            <h3>Regulatory Compliance Systems</h3>
            <p>
              Software solutions for FDA compliance, quality management, audit
              trails, and documentation.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>FDA Compliance Tracking</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Quality Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Audit Trail Systems</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Document Management</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">100%</div>
                <div className="stat-label">Compliance Rate</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">70%</div>
                <div className="stat-label">Faster Audits</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Clinical Trial Card */}
          <div className="pharma-service-card">
            <div className="pharma-service-icon">
              <div className="pharma-icon pharma-icon-clinical"></div>
            </div>
            <h3>Clinical Trial Management</h3>
            <p>
              Technology solutions for clinical trial management, patient
              recruitment, and data collection.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Patient Recruitment Tools</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Trial Data Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Monitoring & Reporting</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Regulatory Documentation</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">40%</div>
                <div className="stat-label">Faster Recruitment</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">90%</div>
                <div className="stat-label">Data Accuracy</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Telemedicine Card */}
          <div className="pharma-service-card">
            <div className="pharma-service-icon">
              <div className="pharma-icon pharma-icon-telemedicine"></div>
            </div>
            <h3>Telemedicine Platforms</h3>
            <p>
              Integrated telemedicine solutions for remote consultations,
              e-prescriptions, and patient engagement.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Virtual Consultations</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>E-Prescription Services</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Patient Engagement Tools</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Health Record Integration</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">60%</div>
                <div className="stat-label">Increased Access</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">45%</div>
                <div className="stat-label">Cost Reduction</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>
        </div>

        <div className="pharma-services-cta">
          <h3>Ready to transform your pharmaceutical business?</h3>
          <p>
            Schedule a free consultation with our pharmaceutical technology
            experts to discuss your specific needs.
          </p>
          <div className="services-cta-buttons">
            <div className="pharma-consultation-container">
              <button
                className="pharma-primary-btn pharma-pulse"
                onClick={handleButtonClick}
              >
                Book a Consultation
              </button>

              {showModal && (
                <div className="pharma-modal-overlay">
                  <div className="pharma-modal-content">
                    <button
                      className="pharma-close-btn"
                      onClick={handleCloseModal}
                    >
                      &times;
                    </button>

                    <h2 className="pharma-modal-title">
                      Pharmaceutical Technology Consultation
                    </h2>
                    <p className="pharma-modal-subtitle">
                      Select an area you need consultation on:
                    </p>

                    <div className="pharma-options-grid">
                      {consultationOptions.map((option) => (
                        <div
                          key={option.id}
                          className={`pharma-option-card ${
                            selectedOption?.id === option.id ? "selected" : ""
                          }`}
                          onClick={() => handleOptionSelect(option)}
                        >
                          <h3 className="pharma-option-title">
                            {option.title}
                          </h3>
                          <p className="pharma-option-desc">
                            {option.description}
                          </p>
                        </div>
                      ))}
                    </div>

                    <button
                      className={`pharma-whatsapp-btn ${
                        selectedOption ? "active" : ""
                      }`}
                      onClick={handleWhatsAppRedirect}
                      disabled={!selectedOption}
                    >
                      Continue to WhatsApp
                    </button>
                  </div>
                </div>
              )}
            </div>
            <button className="pharma-btn pharma-btn-secondary">
              View Case Studies
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="pharma-stats">
        <div className="pharma-stats-container">
          <div className="pharma-stat">
            <h3 className="pharma-stat-number" data-count="250">
              250
            </h3>
            <p className="pharma-stat-label">Pharmaceutical Projects</p>
          </div>
          <div className="pharma-stat">
            <h3 className="pharma-stat-number" data-count="250">
              215
            </h3>
            <p className="pharma-stat-label">Client Satisfaction</p>
          </div>
          <div className="pharma-stat">
            <h3 className="pharma-stat-number" data-count="11">
              11
            </h3>
            <p className="pharma-stat-label">Years Experience</p>
          </div>
          <div className="pharma-stat">
            <h3 className="pharma-stat-number" data-count="40">
              40
            </h3>
            <p className="pharma-stat-label">Countries Served</p>
          </div>
        </div>
      </section>

      {/* Tech Stack Section */}
      <div className="tech-slider-container" ref={containerRef}>
        <h2 className="tech-slider-title">Tools & Tech Stack</h2>
        <div className="tech-slider-divider"></div>

        {/* First row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row1Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow1.map((tech, index) => (
              <div key={`row1-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Second row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row2Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow2.map((tech, index) => (
              <div key={`row2-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <section className="pharma-cta">
        <div className="pharma-cta-content">
          <h2>Ready to Transform Your Pharmaceutical Business?</h2>
          <p>
            Contact us today to discuss how our pharmaceutical technology
            expertise can help your business innovate and grow.
          </p>
          <a href="/contact-us">
            <button className="pharma-btn pharma-btn-primary pharma-btn-large">
              Schedule a Consultation
            </button>
          </a>
        </div>
      </section>

      <Testimonial />
    </div>
  );
};

export default Pharma;
